/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { offEvent, onEvent } from "@adapptio/lib-shared";
import React, { FC, useEffect, useState } from "react";
import { ResourcePathBreadcrumbs } from "../../../../ui/components/ResourcePathBreadcrumbs";
import { ActionEditorView } from "../ActionEditorView";

export interface IActionEditorSecondaryToolbarProps {
	view: ActionEditorView;
}

export const ActionEditorSecondaryToolbar: FC<IActionEditorSecondaryToolbarProps> = ({ view }) => {
	const [ resourceInfo, setResourceInfo ] = useState(() => ({
		resource: view.getResource(),
		parentList: view.getResourceParentList(),
		isBeingSaved: view.isBeingSaved()
	}));

	useEffect(() => {
		const handleResourceInfoChange = () =>
			setResourceInfo({
				resource: view.getResource(),
				parentList: view.getResourceParentList(),
				isBeingSaved: view.isBeingSaved()
			});

		onEvent(view.onResourceInfoChanged, handleResourceInfoChange);

		return () => {
			offEvent(view.onResourceInfoChanged, handleResourceInfoChange);
		};
	}, [ view ]);

	return (
		<ResourcePathBreadcrumbs
			parentList={resourceInfo.parentList}
			resourceName={resourceInfo.resource?.descriptor?.name}
			resourceId={resourceInfo.resource?.id}
			maxVisibleCrumbs={12}
		/>
	);
};
